import { getDefaultSourceId, storeDefaultSourceId } from 'UTILS/storage';
import { store } from 'SRC/store';
import { SUPPORTED_BROWSER_VERSIONS } from './navigator';

export let getStoredDeviceId = getDefaultSourceId;
export let storeDeviceId = storeDefaultSourceId;
export let onUnhandledError = (error) => console.error('Unhandled error:', error);
export let onTrackedClick = () => {};
export let onTrackedResult = () => {};
export let getBrowserAndOSInfo = (navigatorDetails) => {
  const browserMinVersion = SUPPORTED_BROWSER_VERSIONS[navigatorDetails.browser];
  const capitalizeBrowserName = navigatorDetails.browser.charAt(0).toUpperCase() + navigatorDetails.browser.slice(1);
  let result = {
    resultLevel: 'error',
    os: navigatorDetails.os,
    browserVersion: navigatorDetails.version,
    browserName: capitalizeBrowserName,
  };

  if (!navigatorDetails.webRTCsupport) {
    result.message = 'browser_not_meeting_requirements';
  }
  if (navigatorDetails.browser !== 'safari' && navigatorDetails.os === 'iOS') {
    result.message = 'browser_not_safari_on_iOS';
  } else if (navigatorDetails.browser !== 'chrome' && navigatorDetails.os === 'Android') {
    result.message = 'browser_not_chrome_on_android';
  } else if (browserMinVersion) {
    if (browserMinVersion <= navigatorDetails.version) {
      result.message = 'browser_supported';
      result.resultLevel = 'success';
    } else {
      result.message = 'browser_outdated';
      result.browserMinVersion = browserMinVersion;
    }
  } else {
    result.message = 'browser_not_supported';
  }
  return result;
};

export const initializeCallbacks = ({
  storeDeviceId: _storeDeviceId,
  getStoredDeviceId: _getStoredDeviceId,
  onUnhandledError: _onUnhandledError,
  onTrackedClick: _onTrackedClick,
  onTrackedResult: _onTrackedResult,
  getBrowserAndOSInfo: _getBrowserAndOSInfo,
  localStorageKey,
}) => {
  if (typeof localStorageKey === 'string') {
    if (typeof _storeDeviceId === 'function' && typeof _getStoredDeviceId === 'function') {
      console.error('Self Test misuse --- "localStorageKey" will not be used. Behavior is overridden by the "storeDeviceId" and "getStoredDeviceId" options.');
    } else {
      storeDeviceId = (...args) => storeDefaultSourceId(...args, localStorageKey);
      getStoredDeviceId = (...args) => getDefaultSourceId(...args, localStorageKey);
    }
  }

  if (typeof _storeDeviceId === 'function') {
    if (typeof _getStoredDeviceId !== 'function') {
      console.error('Self Test misuse --- "storeDeviceId" is well defined but "getStoredDeviceId" is not. Using default behavior instead. Check your "getStoredDeviceId" option.');
    } else {
      storeDeviceId = _storeDeviceId;
    }
  } else if (_storeDeviceId != null) {
    console.error('Self Test misuse --- "storeDeviceId" is not a function. Using default behavior instead. Check your "storeDeviceId" option.');
  }

  if (typeof _getStoredDeviceId === 'function') {
    if (_storeDeviceId !== 'function') {
      console.error('Self Test misuse --- "getStoredDeviceId" is well defined but "storeDeviceId" is not. Using default behavior instead. Check your "storeDeviceId" option.');
    } else {
      getStoredDeviceId = _getStoredDeviceId;
    }
  } else if (_getStoredDeviceId != null) {
    console.error('Self Test misuse --- "getStoredDeviceId" is not a function. Using default behavior instead. Check your "getStoredDeviceId" option.');
  }

  if (typeof _onUnhandledError === 'function') {
    onUnhandledError = (error) => _onUnhandledError(error, store?.getState());
  } else if (_onUnhandledError != null) {
    console.error('Self Test misuse --- "onUnhandledError" is not a function. Using default behavior instead. Check your "onUnhandledError" option.');
  }

  if (typeof _onTrackedClick === 'function') {
    onTrackedClick = _onTrackedClick;
  } else if (_onTrackedClick != null) {
    console.error('Self Test misuse --- "onTrackedClick" is not a function. Using default behavior instead. Check your "onTrackedClick" option.');
  }

  if (typeof _onTrackedResult === 'function') {
    onTrackedResult = _onTrackedResult;
  } else if (_onTrackedResult != null) {
    console.error('Self Test misuse --- "onTrackedResult" is not a function. Using default behavior instead. Check your "onTrackedResult" option.');
  }

  if (typeof _getBrowserAndOSInfo === 'function') {
    getBrowserAndOSInfo = _getBrowserAndOSInfo;
  } else if (_getBrowserAndOSInfo != null) {
    console.error('Self Test misuse --- "getBrowserAndOSInfo" is not a function. Using default behavior instead. Check your "getBrowserAndOSInfo" option.');
  }
};
